export default __webpack_public_path__ + "static/about-1f3855d54c1185d6010c006333a8342d.jpg";